import request from "superagent";

import { refreshCredentials } from "../utils/securityUtil";
import { getJwtToken } from "./user";
import env from "../constants/env";

export function sendLearningEvent(userLoginId, userLoginEmail, courseIdentifier, courseName, courseId, courseVersion, courseComments, courseScore) {
	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const learningEvent = {
				"userLoginId": userLoginId,
				"userLoginEmail": userLoginEmail,
				"courseIdentifier": courseIdentifier,
				"courseName": courseName,
				"courseId": courseId,
				"courseVersion": courseVersion,
				"courseComments": courseComments,
				"courseScore": courseScore
			};

			// Ok accept it
			request.post(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.healthStream.learningEvent}`)
				.set("Authorization", getJwtToken())
				.set("Content-Type", "application/json")
				.send(JSON.stringify(learningEvent))
				.then(res => {
					resolve(res.body);
				}).catch(err => {
					reject(err);
				});
		});
	});
}